import Joi from 'joi';

/**
 * Schema for operator user-app settings updates.
 */
export const updateUserAppSettingsSchema = () =>
  Joi.object({
    settingsValues: Joi.object().unknown(true).required().messages({
      'any.required': 'validations|user-app-settings-values|required',
      'object.base': 'validations|user-app-settings-values|must-be-object',
    }),
  }).unknown();
